
















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";

@Component
export default class DeleteDialog extends Vue {
  @namespace('practices').Action('deletePractice') actionDeletePractice!: any;
  @Prop({ default: null }) practiceId!: number;
  deleteBtn: boolean = false;

  close() {
    this.$root.$emit("closeDeleteDialog");
  }
  
  async confirmDeleteDialog() {
    const { practiceId } = this;

    try {
      let results = await this.actionDeletePractice({
        practiceId
      });
      
      this.close();
    } catch (err) {
      console.log(err);
       this.close();
    }
  }
  deleteRule(val: string) {
    const result: boolean = val === "delete practice";
    this.deleteBtn = result;
    return result;
  }
}
